<template>
  <div>
    <div id="BMapContainer"></div>
    <div class="page_container">
      <transition name="modal">
        <div class="modal-mask" v-if="modal.showModal">
          <div class="modal-wrapper">
            <div class="modal-container">
              <h3>{{ modal.title }}</h3>
              <div class="modal-body">
                {{ modal.body }}
              </div>
              <div class="modal-footer">
                <button class="modal-default-button" @click="modal.showModal = false">
                  {{ modal.closeName }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <div id="pageWrapper" class="page-wrapper">
        <div>
          <div class="search_box">
            <div class="input_container">
              <i class="ico_search"></i>
              <input type="text" name="search_box" id="Search" v-model="searchText" placeholder="搜索门店" />
              <i class="ico_clear" v-if="showClear" @click="clearInput"></i>
            </div>
            <div class="choose_city" @click="toCityPage">
              <span>{{ city }}</span>
              <img src="../images/arrow_right.png" alt="">
            </div>
          </div>

          <div class="pageHeader">
            <img src="../images/hourglass.png" alt="" @click="showCustomPopupClick">
            <span v-if="hasData">该城市共{{ placelist.length }}家门店</span>
          </div>

          <ul class="place_list">
            <li v-for="(item, index) in placelist" :key="index" @click="toMapDetail(item)"
              :class="{ li0: item.status == 0 || setStatusWords(item).isInOpenTime, bdb: 1 == 1 }"
              v-show="item.storeId != 633">
              <div class="store_name">
                <strong>
                  <span :style="{ 'max-width': setStatusWords(item).words ? 'calc(100% - 82px)' : '100%' }">{{ item.name
                    === "荆州美佳华店" ? "海伦司越大排档（荆州美佳华店）" : item.name }}</span>
                  <span
                    :style="{ color: setStatusWords(item).color, background: setStatusWords(item).bgColor, padding: '4px 12px', 'border-radius': '13px', 'margin-left': '6px' }">{{
                      setStatusWords(item).words }}</span>
                </strong>
                <span :class="{ willBeOpen: item.status == 0 || setStatusWords(item).isInOpenTime, distance: 1 == 1 }"
                  v-html="normalizeDistance(item.distance)"></span>
              </div>

              <div class="store_detail">
                <div class="store_address">
                  <div>
                    <p>{{ isStringNotNull(item.companyAddress) ? item.companyAddress :
                      isStringNotNull(item.addressGuide) ? item.addressGuide : item.address }}</p>
                    <img :src="icons[0]" alt="" v-if="visible(0, item)" />
                    <img :src="icons[1]" alt="" v-if="visible(1, item)" />
                  </div>
                  <div>
                    <span v-if="item.status !== 0 && !setStatusWords(item).isInOpenTime">
                      营业时间：{{ item.businessOpenTime ? item.businessOpenTime : businessOpenTime
                      }}-次日{{ item.businessCloseTime ? item.businessCloseTime : businessCloseTime }}
                    </span>
                    <span v-else></span>
                    <img :src="icons[2]" alt="" v-if="visible(2, item)"
                      @click="callStore(item.companyPhone ? item.companyPhone : item.telephoneFixed, $event)" />
                    <img :src="icons[3]" alt="" v-if="visible(3, item)"
                      @click="callStore(item.companyPhone ? item.companyPhone : item.telephoneFixed, $event)" />
                  </div>
                </div>
              </div>
              <div class="store_access">
                <b>{{ item.name == nearestStoreName ? "距离最近" : "" }}</b>
              </div>
            </li>
          </ul>
          <div class="no_data" v-if="!hasData">
            <i></i>
            搜索无结果呢，换个姿势试试吼~
          </div>
        </div>
      </div>
      <popup ref="CustomPopupRef">
        <div slot="PoperContent" class="PoperContentView">
          <ul>
            <li v-for="(type, index) in storeTypes" :key="index" class="bdb" @click="filterStore(type.status)">{{
              type.name }}</li>
          </ul>
          <div class="btn_cancel" @click="closeButton">取消</div>
        </div>
      </popup>
    </div>
    <transition name="router-slid" mode="out-in">
      <router-view></router-view>
    </transition>
    <loading v-if="showLoading"></loading>
  </div>
</template>
<script>
import PinyinEngine from "pinyin-engine";
import BScroll from "better-scroll";
import moment from "moment";
import fetch from "map/utils/fetch";
import { filterStores } from "map/utils/env.js";
import loading from "map/loading";
import remoteLoad from "map/utils/remoteLoad.js";
import {
  setStore,
  getStore,
  removeStore,
  isStringNotNull,
  myTrim,
  BgpsToGgps
} from "map/utils/util";
import popup from "map/popup";
const statuslabelMap = {
  0: {
    words: '筹备中',
    color: '#E83E44',
    bgColor: '#FFEDED',
  },
  1: {
    words: '正常营业',
    color: '#FFFFFF',
    bgColor: '#E83E44',
  },
  2: {
    words: '正常营业',
    color: '#FFFFFF',
    bgColor: '#E83E44',
  },
  3: {
    words: '暂停营业',
    color: '#FFFFFF',
    bgColor: '#D8D8D8',
  },
};
const isOpening = openTime => new Date(openTime).getTime() > new Date().getTime();

export default {
  data() {
    return {
      modal: {
        showModal: false,
        title: '提示',
        body: '出错了',
        closeName: '好的'
      },
      baiduCityAndDistrict: {
        district: '',
        city: ''
      },//百度定位的城市区县
      city: "武汉",
      BKey: "TR9oRN8Z73rpnB7GhSRn9D1V51YPLVKm",//百度地图
      showLoading: false,
      hasData: true, //搜索数据是否为空
      showClear: false, //是否展示清除按钮
      placelist: [],
      searchList: [],
      searchText: "",
      nearestStoreName: "",
      locationObj: {
        longitude: "",
        latitude: "",
      },
      obj: {},
      AMap: null,
      options: ["name"],
      pinyinEngine: null,
      scroll: null,
      wxReady: false, //微信注册文件是否准备好
      status: 2,
      icons: [
        require("../images/gray_guide.png"),
        require("../images/guide.png"),
        require("../images/gray_phone.png"),
        require("../images/phone.png")
      ],
      businessOpenTime: "19:00",
      businessCloseTime: "02:00",
      storeTypes: [
        { status: 999, name: "全部" },
        { status: "1,2", name: "正常营业" },
        { status: 0, name: "筹备中" },
        // { status: 1, name: "试营业" },
        { status: 3, name: "暂停营业" }
      ]
    };
  },
  created() {
    var url = window.location.href; //当前页面的地址
    var reg = /([^?&=]+)=([^?&=]+)/g,
      obj = {},
      str = url;
    url.replace(reg, function () {
      obj[arguments[1]] = arguments[2];
    })
    for (var keyName in obj) {
      if (keyName == name) {
        return obj[keyName];
        // break;
      }
    }
    console.log(obj);
    this.obj = obj
    this.showLoading = true;
    remoteLoad(`https://api.map.baidu.com/api?v=1.0&type=webgl&ak=${this.BKey}&callback=${this.getLocation()}`).catch((e) => {
      console.log('catch', e.type);
    });
    remoteLoad(`https://res.wx.qq.com/open/js/jweixin-1.4.0.js`).then(() => {
      this.getWechatJsConfig()
    });
  },
  mounted() {
    // 获取页面容器,用于添加滚动事件
    this.pageWrapper = document.getElementById("pageWrapper");
    //window.myvue = this;
  },
  computed: {},
  watch: {
    $route(to, from) {
      if (from.path == "/map/city") {
        const cityName = getStore("map-city");
        // console.log(cityName);
        let timestamp = getStore("map-timestamp");
        if (new Date().getTime() - parseInt(timestamp) > 10 * 60 * 1000) {
          return;
        }
        removeStore("map-city"); //从city页面返回清除掉localstorage，以免从city页面点返回按钮会一直存在
        const cities = JSON.parse(getStore("map-storeList"));
        this.getStoresByCityName(cities, cityName);
      }
    },
    searchText(val) {
      // 去空格
      val = myTrim(val);
      if (!isStringNotNull(val)) {
        // document.getElementById("Search").blur();
        this.showClear = false;
        this.placelist = this.searchList;
        this.hasData = this.placelist.length > 0;
        return;
      }
      this.showClear = true;
      this.placelist = this.pinyinEngine.query(val);
      this.hasData = this.placelist.length > 0;
    },
  },
  components: { loading, popup },
  methods: {
    visible(type, item) {
      // 导航icon
      if (type == 0) {
        // 筹备中
        return item.status == 0
      }
      if (type == 1) {
        // 不是筹备中
        return item.status !== 0
      }
      // 电话icon
      if (type == 2) {
        // 筹备中或暂停营业
        return (item.status == 0 || item.status == 3) && (item.companyPhone || item.telephoneFixed)
      }
      if (type == 3) {
        // 试营业或正在营业
        return item.status == 1 || item.status == 2
      }
    },
    showCustomPopupClick() {
      this.$refs.CustomPopupRef.showCustom();
    },
    closeButton() {
      this.$refs.CustomPopupRef.maskClick();
    },
    filterStore(status) {
      if (status == 999) {
        this.placelist = this.searchList;
      } else if (status == "1,2") {
        status = status.split(',').map(status => parseInt(status));
        this.placelist = this.searchList.filter(store => status.includes(store.status));
      } else {
        this.placelist = this.searchList.filter(store => store.status == status);
      }
      this.hasData = this.placelist.length > 0;
      this.closeButton();
    },
    getLocation() {
      // 监听BMapGL是否加载完成
      var millionTime = Date.now();
      var timer = setInterval(() => {
        if (typeof (BMapGL) === 'object' && BMapGL.Map) {
          clearInterval(timer);
          this.getLocationByBaiDu();
        } else if (Date.now() - millionTime > 5 * 1000) {
          clearInterval(timer);
          this.hasData = false;
          this.showLoading = false;
        }
      }, 300);
    },
    getLocationByBaiDu() {
      var self = this;
      new BMapGL.Map("BMapContainer");
      var geolocation = new BMapGL.Geolocation();
      var options = {
        enableHighAccuracy: true,
        // 	允许返回指定事件内的缓存结果，单位为毫秒。如果为0，则每次请求都获取最新的定位结果。默认为10分钟
        maximumAge: 0,
        timeout: 3000
      };
      geolocation.getCurrentPosition(function (result) {
        var status = this.getStatus();
        if (status == BMAP_STATUS_SUCCESS) {
          const { city, district } = result.address;
          if (!city && !district) {
            self.alert("暂时获取不到位置信息")
            self.showLoading = false;
            self.hasData = false;
            return;
          }
          const tempLocationObj = BgpsToGgps(result.longitude, result.latitude)
          self.locationObj = {
            longitude: tempLocationObj.lng,
            latitude: tempLocationObj.lat,
          };
          self.baiduCityAndDistrict.district = district;
          self.baiduCityAndDistrict.city = city;
          self.city = self.cityTrim(city || district);
          console.log("first:", self.city);

          setStore("map-currentCity", self.city);
          // 去初始化数据
          self.initData();
        } else {
          if (status == BMAP_STATUS_UNKNOWN_LOCATION) {
            self.alert("暂时获取不到位置信息")
          } else if (status == BMAP_STATUS_PERMISSION_DENIED) {
            self.alert("位置服务被拒绝")
          } else if (status == BMAP_STATUS_TIMEOUT) {
            self.alert("获取信息超时")
          } else {
            self.alert("未知错误")
          }
          self.showLoading = false;
          self.hasData = false;
        }
      }, options);
    },

    // 数据初始化
    initData() {
      const limit = 100;
      const { longitude, latitude } = this.locationObj;
      const self = this;
      let activityId = null
      let platform = null
      if (this.obj.activityId) {
        activityId = this.obj.activityId;
        platform=1
      }
      // 请求接口，传入经纬度和limit
      fetch("store/getNearbyStore", {
        longitude,
        latitude,
        limit,
        activityId,
        platform
      }).then((data) => {
        self.showLoading = false;
        if (data.code > 0) {
          // 对数据进行处理
          // 对searchList赋值
          self.filterData(data.results);
          self.storeListDealWith(self.searchList);
          // 数据初始化
          self.placelist = self.searchList;
          // 判断数据是否为空
          self.hasData = self.placelist.length > 0;
          // 第一个参数:查询的数据列表,第二个参数:查询的关键字或键值
          self.pinyinEngine = new PinyinEngine(self.searchList, self.options);
          // 设置滚动效果
          self.scroll = new BScroll(self.pageWrapper, {
            probeType: 3,
            click: true,
            tap: true,
          });
        }
      })
        .catch((error) => {
          console.error(error.message);
          self.showLoading = false;
        });
    },
    storeListDealWith(list) {
      var topList = list.filter(store => store.status == 1 || store.status == 2);
      var restList = list.filter(store => store.status !== 1 && store.status !== 2);
      this.searchList = topList.concat(restList);
    },

    toCityPage() {
      const { longitude, latitude } = this.locationObj;
      this.$router.push({
        path: "/map/city",
        query: {
          city: this.city,
          longitude: parseFloat(longitude),
          latitude: parseFloat(latitude),
          activityId:this.obj.activityId
        }
      });
    },
    toMapDetail(item) {
      if (this.wxReady) {
        wx.openLocation({
          latitude: parseFloat(item.lat), // 纬度，浮点数，范围为90 ~ -90
          longitude: parseFloat(item.lon), // 经度，浮点数，范围为180 ~ -180。
          name: item.name, // 位置名
          address: item.companyAddress
            ? item.companyAddress
            : item.addressGuide, // 地址详情说明
          scale: 18, // 地图缩放级别,整形值,范围从1~28。默认为最大
          infoUrl: "", // 在查看位置界面底部显示的超链接,可点击跳转
        });
      } else {
        this.$router.push({
          path: "/map/mapDetail",
          query: {
            longitude: item.lon,
            latitude: item.lat,
            originLongitude: this.locationObj.longitude,
            originLatitude: this.locationObj.latitude,
            address: item.companyAddress
              ? item.companyAddress
              : item.addressGuide,
            name: item.name,
          },
        });
      }
    },

    clearInput() {
      this.searchText = "";
      this.showClear = false;
    },
    isStringNotNull(str) {
      return isStringNotNull(str)
    },
    // 处理距离
    normalizeDistance(distance) {
      const num = parseInt(distance);
      if (num < 0) {
        return 0;
      } else if (num < 100) {
        return num + "<i>m</i>";
      } else {
        return (num / 1000).toFixed(2) + "<i>km</i>";
      }
    },

    // 设置门店状态
    setStatusWords(item) {
      let status = parseInt(item.status);
      // 只有即将开业才判断开业时间
      if (isStringNotNull(item.openTime) && status === 0) {
        if (isOpening(item.openTime)) {
          const words = `${moment(new Date(item.openTime).getTime()).format("MM月DD日")}开业`;
          return Object.assign({}, statuslabelMap[0], { words, isInOpenTime: true });
        }
      }
      return statuslabelMap[status] || {};
    },

    // 判断营业中的门店是否在营业时间段？
    ifRelax(item) {
      if (item.status == 2 || item.status == 1) {
        if (isStringNotNull(item.openTime) && isOpening(item.openTime)) return false;
        return !this.isBetweenTime(item);
      }
    },
    isBetweenTime(item) {
      const openTime = isStringNotNull(item.businessOpenTime) ? item.businessOpenTime : this.businessOpenTime;
      const closeTime = isStringNotNull(item.businessCloseTime) ? item.businessCloseTime : this.businessCloseTime;
      const nowDate = `${moment().year()}/${this.format(moment().month() + 1)}/${this.format(moment().date())}`;
      const nextDate = `${moment().add(1, 'day').year()}/${this.format(moment().add(1, 'day').month() + 1)}/${this.format(moment().add(1, 'day').date())}`;
      const newOpenTime = moment(`${nowDate} ${openTime}`).format('YYYY/MM/DD HH:mm:ss');
      const newCloseTime = moment(`${nextDate} ${closeTime}`).format('YYYY/MM/DD HH:mm:ss');
      const isBetween = moment().isBetween(newOpenTime, newCloseTime, null, []);
      return isBetween;
    },
    format(Number) {
      return Number < 10 ? '0' + Number : Number;
    },
    // 电话
    callStore(tel, event) {
      if (isStringNotNull(tel)) {
        location.href = `tel:${tel}`;
        event.stopPropagation();
      }
    },
    // 过滤数据
    filterData(results, name) {
      //过滤经纬度为空的情况
      let that = this;
      try {
        let tempData = [];
        results.map(item => {
          item.storeId = item.storeId ? item.storeId : item.id;
          return item;
        }).forEach((item) => {
          if (!item.lon || !item.lat) {
            const location = isStringNotNull(item.location2) ? item.location2 : (isStringNotNull(item.location) ? item.location : '');
            if (location) {
              const locationObj = location.split(",");
              item.lon = locationObj[0];
              item.lat = locationObj[1];
            }
          }
          if (isStringNotNull(item.lon) && isStringNotNull(item.lat)) { 
            let needFilter = false;
            filterStores.forEach(name => {
              if (item.name == name) needFilter = true;
              if (item.name.includes(name)) {
                if (name === '总部') {
                  if (item.storeId !== 1510) needFilter = true;
                } else {
                  needFilter = true;
                }
              }
            });
            // 过滤没有地址的门店
            if (!item.companyAddress && !item.addressGuide && !item.address) needFilter = true;
            !needFilter && tempData.push(item);
          }
        });
        // 如果有城市名称，不需要对数据进行筛选；如果没有，则筛选只属于武汉的门店
        // 过滤停业的门店
        //有数据的话就把城市换成数据第一条
        if (tempData.length > 0) {
          var cityName = '';
          for (let i = 0; i < tempData.length; i++) {
            var cityTmp = that.cityTrim(tempData[i].city);
            if (cityTmp) {
              cityName = cityTmp;
              //console.log({cityTmp});
              break;
            } else {
              // console.log({cityTmp});
            }
          }
          if (cityName) {
            that.city = cityName;
            setStore("map-currentCity", cityName);
          }
          console.log({ cityName });

        }
        console.log("最后计算城市:", that.city);


        that.searchList = tempData.slice(0).filter(item => (name ? true : that.cityEqTrim(item.city, that.city)) && item.status !== 4);
        that.nearestStoreName = that.searchList[0] ? that.searchList[0].name : "";
      } catch (error) {
        console.error(error);
      }
    },
    cityTrim(cityName) {
      let tmp = cityName || '';
      if (tmp) {
        return tmp.replace(/县$|区$|市$/, "");
      }
      return tmp;
    },
    /* 
    判断两个城市去除了后缀是否相同
    会有bug，比如武汉区会等同武汉市
    */
    cityEqTrim(aCity, bCity) {
      let a = this.cityTrim(aCity);
      let b = this.cityTrim(bCity);
      if (a && b && a === b) {
        return true;
      }
      return false;
    }
    ,
    // 根据城市名称获取数据
    getStoresByCityName(cities, cityName) {
      console.log(cities, cityName);
      
      cities.forEach((item) => {
        if (item.name === cityName) {
          item.stores.forEach((ele) => {
            if (!ele.distance) {
              ele.distance = this.distanceByLnglat(
                ele.lon,
                ele.lat, //目的地经纬度
                this.locationObj.longitude,
                this.locationObj.latitude //当前所在位置经纬度
              );
            }
            ele.address = ele.addr;
            ele.telephoneFixed = ele.companyPhone;
            ele.addressGuide = ele.companyAddress;
          });
          this.filterData(item.stores, cityName);
          this.searchList.sort((a, b) => parseFloat(a.distance) - parseFloat(b.distance));
          this.nearestStoreName = this.searchList[0] ? this.searchList[0].name : "";
          this.storeListDealWith(this.searchList);

          this.city = cityName;
          this.placelist = this.searchList;
          this.hasData = this.placelist.length > 0;
          this.pinyinEngine = new PinyinEngine(this.searchList, this.options);
        }
      });
    },
    // 距离排序算法,设置门店由近到远排序
    distanceByLnglat(lng1, lat1, lng2, lat2) {
      const radLat1 = this.Rad(lat1);
      const radLat2 = this.Rad(lat2);
      const a = radLat1 - radLat2;
      const b = this.Rad(lng1) - this.Rad(lng2);
      let s =
        2 *
        Math.asin(
          Math.sqrt(
            Math.pow(Math.sin(a / 2), 2) +
            Math.cos(radLat1) *
            Math.cos(radLat2) *
            Math.pow(Math.sin(b / 2), 2)
          )
        );
      s = s * 6378137.0; // 取WGS84标准参考椭球中的地球长半径(单位:m)
      s = Math.round(s * 10000) / 10000;
      return s;
    },
    Rad(d) {
      return (d * Math.PI) / 180.0;
    },

    // 注入配置信息
    getWechatJsConfig() {
      let that = this;
      fetch("wechatjs/JsApiConfig", {
        requestUrl: encodeURIComponent(location.href),
      })
        .then((data) => {
          if (data.code > 0) {
            let results = data.results;
            this.initWechatJs(results);
          } else {
            that.alert(data.message);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    initWechatJs(config) {
      const _this = this;
      if (!wx) {
        return;
      }

      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: config.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
        timestamp: config.timestamp, // 必填，生成签名的时间戳
        nonceStr: config.nonceStr, // 必填，生成签名的随机串
        signature: config.signature, // 必填，签名，见附录1
        jsApiList: [
          "checkJsApi",
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "updateMenuShareTimeline",
          "updateMenuShareAppMessage",
          "hideMenuItems",
          "showMenuItems",
          "hideAllNonBaseMenuItem",
          "showAllNonBaseMenuItem",
          "chooseImage",
          "previewImage",
          "uploadImage",
          "downloadImage",
          "getNetworkType",
          "hideOptionMenu",
          "showOptionMenu",
          "closeWindow",
          "scanQRCode",
          "chooseWXPay",
          "openProductSpecificView",
          "openLocation",
          "getLocation",
        ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });

      wx.ready(function () {
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
        _this.wxReady = true;
        wx.onMenuShareAppMessage({
          title: "查找附近门店",	// 分享标题
          desc: "点击查看离你最近的Helens",	// 分享描述
          link: "https://mobile.helensbar.com/map/index.html",	// 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: 'https://mobile.helensbar.com/pic/Helens_logo_new_red.png',	// 分享图标
          success: function () {
            // alert("分享成功");
          },
          cancel: function () {
            // alert("分享取消");
          }
        });
        wx.onMenuShareTimeline({
          title: "查找附近门店",	// 分享标题
          desc: "点击查看离你最近的Helens",	// 分享描述
          link: "https://mobile.helensbar.com/map/index.html",	// 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: 'https://mobile.helensbar.com/pic/Helens_logo_new_red.png',	// 分享图标
          success: function () {
            // alert("分享成功");
          },
          cancel: function () {
            // alert("分享取消");
          }
        });
      });

      wx.error(function (res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        console.log(res)
      });
    },
    alert(msg) {
      this.tip('提示', msg, '好的');
    },
    tip(title, tBody, closeName) {
      var self = this;

      self.modal = {
        showModal: true,
        title: title || '标题',
        body: tBody || '内容',
        closeName: closeName || '好的',
      }
    }


  },
};
</script>
<style>
.page_container {
  position: absolute;
  right: 0;
  left: 0;
  height: 100%;
  overflow: scroll;
}

.page-wrapper {
  height: 100%;
}

.pageHeader {
  margin: 12px;
  font-size: 16px;
  color: #262626;
  display: flex;
  align-items: center;
}

.pageHeader img {
  width: 168px;
  height: 40px;
  margin-right: 10px;
}

.modal-mask {
  position: fixed;
  z-index: 999;
  background: #26262678;
  left: 0;
  top: 0;
  right: 0;
  padding: 1em;
  border-radius: 6px;
  FONT-VARIANT: JIS04;
  bottom: 0;
}

.modal-wrapper {
  background: #f0f0f0;
  top: calc(36.8% - 60px);
  position: absolute;
  left: 24px;
  right: 24px;
  padding: 16px;
  border-radius: 6px;
  box-shadow: -3px 3px 6px 1px #707070;
  box-sizing: border-box;
}

h3 {
  color: #595959;
  font-weight: 400;
  line-height: 1;
  text-align: center;
}

.modal-body {
  padding: 16px 0;
  text-align: center;
  font-size: 1.3em;
}

.modal-footer {
  text-align: center;
}

button.modal-default-button {
  color: #0c88e8;
  border: navajowhite;
  outline: none;
}

.search_box {
  position: relative;
  font-size: 14px;
  background-color: #ffffff;
  padding: 10px 12px;
}

.choose_city {
  width: 68px;
  height: 30px;
  color: #262626;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 15px;
  border: 1px solid #D2D2D2;
  border-radius: 20px;
  padding: 0 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.choose_city img {
  width: 20px;
  height: 20px;
}

.choose_city::after {
  content: "";
  display: inline-block;
  width: 9px;
  height: 9px;
  border-top: 1px #ffffff solid;
  border-right: 1px #ffffff solid;
  transform: rotate(135deg) translateY(3px);
  margin-left: 10px;
  display: none;
}

.input_container {
  width: 65%;
  position: relative;
}

#Search {
  width: 100%;
  height: 36px;
  border-radius: 20px;
  border: 0;
  padding-left: 46px;
  box-sizing: border-box;
  color: #262626 !important;
  font-size: 15px;
  background-color: #F6F6F6;
}

#Search::placeholder {
  color: #8C8C8C;
}

.ico_search {
  background: url("../images/search.png") 0 0 no-repeat;
  background-size: 100% auto;
  -webkit-background-size: 100% auto;
  display: block;
  width: 23px;
  height: 23px;
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
}

.ico_clear {
  background: url(data:image/png;base64,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) 0 0 no-repeat;
  background-size: 100% auto;
  -webkit-background-size: 100% auto;
  display: block;
  width: 18px;
  height: 18px;
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
}

.place_list li {
  margin: 12px;
  padding: 12px;
  background-color: #ffffff;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
}

.place_list li .distance {
  color: #262626;
  font-size: 18px;
  font-weight: bold;
  margin-left: 12px;
}

.place_list li .distance i {
  font-size: 14px;
  margin-left: 3px;
}

.place_list .li0 .willBeOpen {
  color: #666666 !important;
}

.store_name {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.store_name strong {
  font-size: 18px;
  color: #262626;
  font-weight: bold;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 5px;
  flex: 1;
}

.notInOpenTime {
  display: inline-block;
  width: 90px;
  height: 20px;
  line-height: 23px;
  text-align: center;
  background-color: #ffe8d2;
  color: #ff8a20;
  padding: 0 1.5px;
  margin-left: 3px;
  border-radius: 2px;
  font-size: 14px !important;
}

.store_name strong .store_status {
  width: 63px;
  height: 20px;
  position: relative;
  top: 4px;
  left: 3px;
}

.store_name span {
  display: inline-block;
  font-size: 13px;
}

.store_name strong span:nth-child(1) {
  font-size: 18px;
}

li b {
  font-size: 12px;
  color: #f03f46;
  text-align: right;
}

.place_list li p {
  font-size: 14px;
  display: block;
  margin-bottom: 5px;
  text-align: justify;
  margin-top: 6px;
  width: 80%;
}

.store_detail {
  display: -webkit-box;
  -webkit-box-orient: horizontal;
  -webkit-box-pack: center;
  -webkit-box-align: top;
}

.store_detail .store_address {
  -webkit-box-flex: 1;
  color: #6A6B6C;
  display: flex;
  flex-direction: column;
  padding: 16px 0;
  font-size: 14px;
}

.store_detail .store_address div {
  /* height: 40px; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* margin-bottom: 3px; */
  margin: 10px 0;
}

.store_detail .store_address img {
  width: 24px;
  height: 24px;
}

.store_access {
  text-align: right;
}

.store_detail .to_detail {
  display: block;
  background: url(data:image/svg+xml;base64,PHN2ZyB0PSIxNTcwNTI0ODQ0MTYwIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjQ0MTkiIHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIj48cGF0aCBkPSJNNTEyLjAwNzU2MSAwQzIyOS4yMzkwNjEgMCAwLjAxNTEyMSAyMjkuMjIzOTQgMC4wMTUxMjEgNTExLjk5MjQzOXMyMjkuMjIzOTQgNTEyLjAwNzU2MSA1MTEuOTkyNDQgNTEyLjAwNzU2MVMxMDI0IDc5NC43NzYwNiAxMDI0IDUxMi4wMDc1NjFBNTExLjk5MjQzOSA1MTEuOTkyNDM5IDAgMCAwIDUxMi4wMDc1NjEgMHogbTAgOTUyLjI5NDc0N2MtMjQzLjE2NTc4OCAwLTQ0MC4yODcxODctMTk3LjEyMTM5OS00NDAuMjg3MTg3LTQ0MC4yODcxODZTMjY4Ljg0MTc3MyA3MS43MDUyNTMgNTEyLjAwNzU2MSA3MS43MDUyNTMgOTUyLjI5NDc0NyAyNjguODQxNzczIDk1Mi4yOTQ3NDcgNTEyLjAwNzU2MUE0NDAuMjg3MTg3IDQ0MC4yODcxODcgMCAwIDEgNTEyLjAwNzU2MSA5NTIuMjk0NzQ3eiBtMCAwIiBwLWlkPSI0NDIwIj48L3BhdGg+PHBhdGggZD0iTTc1NC4wMjQxMjkgNTEyLjAwNzU2MWEyOS45MDk5NTEgMjkuOTA5OTUxIDAgMCAxIDAgMTMuODgxMzYyIDI0Ljc2ODcwNiAyNC43Njg3MDYgMCAwIDEtNi41Nzc3NyA4Ljc3MDM2bC0xNTkuMzMzMjQ1IDE1Ny44NjY0NzhhMzYuMTcwMTc0IDM2LjE3MDE3NCAwIDAgMS01MS4xNTUzOTItNTEuMDk0OTA3bDkyLjA4ODc3OS05Mi44MTQ2MDJIMzA2LjY5MDQxMmEzNi41NDgyMDcgMzYuNTQ4MjA3IDAgMSAxIDAtNzMuMDgxMjkxSDYyOS4wNDY1MDFsLTk0LjI4MTM2OS05Mi44MTQ2MDJhMzYuMjE1NTM4IDM2LjIxNTUzOCAwIDAgMSA1MS4xNTUzOTMtNTEuMjc2MzYybDE1NC45NDgwNjQgMTU0LjIzNzM2M2EyMS45MjU5IDIxLjkyNTkgMCAwIDEgNi41Nzc3NyA5LjQ5NjE4MiAyOS45NTUzMTUgMjkuOTU1MzE1IDAgMCAxIDYuNTc3NzcgMTYuODE0ODk3eiBtMCAwIiBwLWlkPSI0NDIxIj48L3BhdGg+PC9zdmc+) 0 0 no-repeat;
  background-size: 100% auto;
  -webkit-background-size: 100% auto;
  width: 16px;
  height: 16px;
  margin-left: 8px;
}

.no_data {
  text-align: center;
  font-size: 14px;
  padding: 40px 0;
  color: #6A6B6C;
}

.no_data i {
  display: block;
  background: url("../images/noData.png") 0 0 no-repeat;
  background-size: 100% 100%;
  -webkit-background-size: 100% auto;
  width: 108px;
  height: 108px;
  margin: 0 auto 8px;
}

.PoperContentView {
  color: #000000;
  background-color: #f0f0f0;
  border-radius: 10px;
}

.PoperContentView ul {
  background-color: #ffffff;
  text-align: center;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.PoperContentView ul li {
  height: 45px;
  line-height: 45px;
  font-size: 14px;
  font-weight: bold;
}

.btn_cancel {
  font-size: 14px;
  height: 50px;
  line-height: 50px;
  background-color: #ffffff;
  text-align: center;
  color: #000000;
  margin-top: 5px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.fade-choose-enter-active,
.fade-choose-leave-active {
  transition: opacity 0.5s;
}

.fade-choose-leave,
.fade-choose-leave-active {
  display: none;
}

.fade-choose-enter,
.fade-choose-leave-active {
  opacity: 0;
}

.router-slid-enter-active,
.router-slid-leave-active {
  transition: all 0.4s;
}

.router-slid-enter,
.router-slid-leave-active {
  transform: translate3d(2rem, 0, 0);
  opacity: 0;
}

.toggle-cart-enter-active,
.toggle-cart-leave-active {
  transition: all 0.3s ease-out;
}

.toggle-cart-enter,
.toggle-cart-leave-active {
  transform: translateY(100%);
}
</style>
